import styled from 'styled-components/macro';

export const MainWrapper = styled.section`
    // height: 95vh;
    height: calc(95vh - 90px);

    width: 95vw;
    overflow: none;
`;

export const LocationsWrapper = styled.section`
    height: calc(100% - 75px);
    overflow: hidden;
    background-color: #faf9f8;
    color: #201f1e;
    padding: 10px;
`;

export const ListWrapper = styled.section`
    width: 100%;
    height: calc(100%);
    flex-direction: column;
    position: relative;
    .ms-DetailsHeader {
        cursor: pointer;
        padding: 0;
        span {
            font-size: 16px;
        }
    }
`;
